/*eslint-disable */
// import AdminNotificationModel from '../../Model/AdminNotification'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let AdminNotifications = {
  /**
   * adminNotificationList
   */
  async adminNotificationList (context, notificationObj) {
    try{
      let post_data = new FormData();
      for (let key in notificationObj) {
        if (notificationObj[key] && notificationObj[key] !== "null") {
          if (key === "whereFilter" && notificationObj[key]) {
            post_data.append('filter', JSON.stringify(notificationObj[key]))
          }
          else {
            post_data.append(key, notificationObj[key]);
          }
        }
      }

      return await request.curl(context, "admin_notification_list", post_data)
      .then(async response => {
        return response
      });

    }
    catch(err){
      console.error('Exception occurred at adminNotificationList() and Exception:',err.message)
    }
  },

  /**
   * adminNotificationCount
   */
  async adminNotificationCount (context, notificationObj) {
    try{

      let post_data = new FormData();  
      for (let key in notificationObj) {
        if ((notificationObj[key] || notificationObj[key] == 0 || notificationObj[key] == 1) && notificationObj[key] !== "null") {
          post_data.append(key, notificationObj[key]);
        }
      }

      return await request.curl(context, "admin_notification_count", post_data)
      .then(async response => {
        return response
      });

    }
    catch(err){
      console.error('Exception occurred at adminNotificationCount() and Exception:',err.message)
    }
  },

  /**
   * adminNotificationView
   */
  async adminNotificationView (context, adminNotificationId) {
    try {      
      let post_data = new FormData();
      post_data.append('notification_id', adminNotificationId);
      return await request.curl(context, "admin_notification_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at adminNotificationView() and Exception:",err.message)
    }    
  },

  /**
   * adminNotificationAdd
   */
  async adminNotificationAdd (context, adminNotificationObj) {
    try{
      let post_data = new FormData();
    
      for (let key in adminNotificationObj) {
        post_data.append(key, adminNotificationObj[key]);
      }

      return await request.curl(context, "admin_notification_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at adminNotificationAdd() and Exception:',err.message)
    }
  },

  /**
   * adminNotificationEdit
   */
  async adminNotificationEdit (context, adminNotificationObj) {
    try{
      let post_data = new FormData();
    
      for (let key in adminNotificationObj) {
        if (adminNotificationObj[key] && adminNotificationObj[key] !== "null") {
          post_data.append(key, adminNotificationObj[key]);
        }
      }

      return await request.curl(context, "admin_notification_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at adminNotificationEdit() and Exception:',err.message)
    }
  },

  /**
   * adminNotificationDelete
   */
  async adminNotificationDelete (context, adminNotificationId) {
    try{
      let post_data = new FormData();
      
      post_data.append('notification_id', adminNotificationId);

      return await request.curl(context, "admin_notification_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at adminNotificationDelete() and Exception:',err.message)
    }
  },

  /**
   * adminNotificationPublishUnpublish
   */
  async adminNotificationPublishUnpublish (context, Noti) {
    try{
      let post_data = new FormData();
      post_data.append('notification_id', Noti.notification_id);
      post_data.append('deleted',Noti.deleted);

      return await request.curl(context, "admin_notification_publish_unpublish", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at admin_notification_publish_unpublish() and Exception:',err.message)
    }
  },
}

export {
  AdminNotifications
}
